/**
 * ****************************************************************************
 * @description     :   Reducer to receive action and change state for page report
 * @created at      :   2020/07/18
 * @created by      :   QuanHVM
 * @package         :   report-daily-react
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

import _ from 'lodash';

/**
 * Factory to create or call api to get data for page report
 * -----------------------------------------
 * @author : QuanHVM- create
 * @access : public
 */
const Factory = {
/**
    * Create data for favorites
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/19 - create
     * @returns: {Array} - List data of favorites
     * @access : public
     */
    GetReports: (condition) => {
        let reports = [];
        let timeLines = [];
        const tmp = [];
        const currentDate = new Date().toISOString().split('T')[0].replace(/-/g, '/');
        try {
            const savedReports = localStorage.getItem('reports');
            const savedTimeLines = localStorage.getItem('timeLines');
            if (savedReports && savedTimeLines) {
                reports = JSON.parse(savedReports);
                timeLines = JSON.parse(savedTimeLines);
            } else {
                reports = [
                    {
                        isChecked: false,
                        id: 3,
                        customer: '株式会社AAA',
                        date: currentDate,
                        time: '10:00',
                        place: '●×事務所',
                        behavior: '紹介',
                        products: [
                            {
                                name: '商品',
                                money: '1,000',
                                quantity: 1,
                            }
                        ],
                        productName: 'LDセミナー',
                        amountOfMoney: '',
                        manager: '田中',
                        result: '●',
                        customerReaction: '良い',
                        cause: '報告なし'
                    },
                    {
                        isChecked: false,
                        id: 7,
                        customer: 'BBB株式会社',
                        date: currentDate,
                        time: '12:00',
                        place: '●×事務所',
                        behavior: '支払',
                        products: [
                            {
                                name: '商品2',
                                money: '2,000',
                                quantity: 12,
                            }
                        ],
                        productName: 'まるの会会員	',
                        amountOfMoney: '3,000,000',
                        manager: '田中',
                        result: '●',
                        customerReaction: '良い',
                        cause: '報告なし'
                    },
                    {
                        isChecked: false,
                        id: 9,
                        customer: '合同会社CCC',
                        date: currentDate,
                        time: '13:00',
                        place: '●×事務所',
                        behavior: '提案',
                        products: [
                            {
                                name: '商品3',
                                money: '1,200',
                                quantity: 5,
                            },
                            {
                                name: '商品4',
                                money: '3,000',
                                quantity: 3,
                            }
                        ],
                        productName: 'BPO',
                        amountOfMoney: '100,000',
                        manager: '田中',
                        result: '●',
                        customerReaction: 'ダメ',
                        cause: '報告なし'
                    }
                ];
                timeLines = [
                    {
                        id: '1',
                        time: '09:00'
                    },
                    {
                        id: '2',
                        time: '09:30'
                    },
                    {
                        id: '3',
                        time: '10:00'
                    },
                    {
                        id: '4',
                        time: '10:30'
                    },
                    {
                        id: '5',
                        time: '11:00'
                    },
                    {
                        id: '6',
                        time: '11:30'
                    },
                    {
                        id: '7',
                        time: '12:00'
                    },
                    {
                        id: '8',
                        time: '12:30'
                    },
                    {
                        id: '9',
                        time: '13:00'
                    },
                    {
                        id: '10',
                        time: '13:30'
                    },
                    {
                        id: '11',
                        time: '14:00'
                    },
                    {
                        id: '12',
                        time: '14:30'
                    },
                    {
                        id: '13',
                        time: '15:00'
                    },
                    {
                        id: '14',
                        time: '15:30'
                    },
                    {
                        id: '15',
                        time: '16:00'
                    },
                    {
                        id: '16',
                        time: '16:30'
                    },
                    {
                        id: '17',
                        time: '17:00'
                    },
                    {
                        id: '18',
                        time: '17:30'
                    },
                    {
                        id: '19',
                        time: '18:00'
                    },
                    {
                        id: '20',
                        time: '18:30'
                    },
                    {
                        id: '21',
                        time: '19:00'
                    },
                    {
                        id: '22',
                        time: '19:30'
                    },
                    {
                        id: '23',
                        time: '20:00'
                    }
                ]
                localStorage.setItem('reports', JSON.stringify(reports));
                localStorage.setItem('timeLines', JSON.stringify(timeLines));
            }
            if (condition) {
                reports = _.filter(JSON.parse(savedReports), (item) => {
                    let matched = true;
                    if (condition.date) {
                        const dateSearch = (condition.date).toISOString().split('T')[0].replaceAll('-', '/');
                        matched = matched && (item.date === dateSearch);
                    } else {
                        if (condition.dateSearch && condition.befAftSelect && condition.dateSearch !== '' && condition.befAftSelect) {
                            const dateSearch = (condition.dateSearch).toISOString().split('T')[0].replaceAll('-', '/');
                            if (condition.befAftSelect && condition.befAftSelect === 'befor') {
                                matched = matched && (item.date < dateSearch);
                            } else {
                                matched = matched && (item.date > dateSearch);
                            }
                        }
                        if (condition.customerName && condition.customerName !== '') {
                            matched = matched && (item.customer.indexOf(condition.customerName) > -1);
                        }
                        if (condition.behavior && condition.behavior !== '') {
                            matched = matched && (item.behavior.indexOf(condition.behavior) > -1);
                        }
                        if (condition.search && condition.search !== '') {
                            matched = matched && ((item.customer.indexOf(condition.search) > -1) || (item.behavior.indexOf(condition.search) > -1));
                        }
                    }
                    return matched;
                });
            }
            // remake data with timeline
            timeLines.forEach((time) => {
                const val = _.find(reports, {
                    time: time.time
                });
                if (val) {
                    tmp.push(val);
                } else {
                    tmp.push({
                        isChecked: false,
                        id: Math.random().toString(36).substr(2, 9),
                        customer: '',
                        date: '',
                        time: '',
                        place: '',
                        behavior: '',
                        products: [],
                        productName: '',
                        amountOfMoney: '',
                        manager: '',
                        result: '',
                        customerReaction: '',
                        cause: ''
                    })
                }
            });
        } catch (e) {
            console.log(`GetReports: ${e.message}`);
        }
        return [tmp, timeLines];
    },
    // destroy reports
    DestroyReports: (listRemove) => {
        try {
            const savedReports = localStorage.getItem('reports');
            if (savedReports) {
                const reports = JSON.parse(savedReports);
                listRemove.forEach(id => {
                    const { length } = reports;
                    let index = -1;
                    for (let i = 0; i < length; i += 1) {
                        if (reports[i].id === id) {
                            index = i;
                            break;
                        }
                    }
                    if (index > -1) {
                        reports.splice(index, 1);
                    }
                });
                localStorage.setItem('reports', JSON.stringify(reports));
            }
        } catch (e) {
            console.log(`DestroyReports: ${e.message}`);
        }
        return true;
    },
    /**
     * Data report detail init
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/25 - create
     * @returns: {Array} - data of report
     * @access : public
     */
    GetReportDetail: (id) => {
        let reports = [];
        let report = {};
        try {
            if (id) {
                const savedReports = localStorage.getItem('reports');
                if (savedReports) {
                    reports = JSON.parse(savedReports);
                    reports.forEach((value) => {
                        if (value.id === id) {
                            report =value;
                        }
                    })
                } else {
                    report = {
                        isChecked: false,
                        id: 0,
                        customer: '',
                        date: '',
                        time: '',
                        place: '',
                        behavior: '',
                        products: [
                            {
                                name: '',
                                money: '',
                                quantity: 0,
                            }
                        ],
                        productName: '',
                        amountOfMoney: '',
                        manager: '',
                        result: '',
                        customerReaction: '',
                        cause: ''
                    };
                }
            } else {
                report = {
                    isChecked: false,
                    id: 0,
                    customer: '',
                    date: '',
                    time: '',
                    place: '',
                    behavior: '',
                    products: [
                        {
                            name: '',
                            money: '',
                            quantity: 0,
                        }
                    ],
                    productName: '',
                    amountOfMoney: '',
                    manager: '',
                    result: '',
                    customerReaction: '',
                    cause: ''
                };
            }
            
        } catch (e) {
            console.log(`GetReportDetail: ${e.message}`);
        }
        return report;
    },
    // add data report
    PostReport: (report) => {
        let reports = [];
        let isEdit = false;
        try {
            const savedReports = localStorage.getItem('reports');
            if(savedReports) {
                reports = JSON.parse(savedReports);
                reports.forEach((value, index) => {
                    if(value.id === report.id) {
                        reports[index] = report;
                        isEdit = true;
                    }
                });
                if (!isEdit) {
                    reports.push(report);
                }
                console.log(reports);
                localStorage.setItem('reports', JSON.stringify(reports));
            }
        } catch (e) {
            console.log(`PostReport: ${e.message}`);
        }
    },

    /* clearstorage
     * -----------------------------------------
     * @author : QuanHVM - 2022/07/19 - create
     * @returns: {Array} - List data of report
     * @access : public
     */
    ClearStorage: () => {
        try {
            localStorage.removeItem('reports');
        } catch (e) {
            console.log(`ClearStorage: ${e.message}`);
        }
    }
}

export default Factory;